GP.GPMod('EditAccount',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;
        }
    };

    var gui = {
        init: function() {
            this.$email_pref_accept_email = $('#email-pref-accept-email');
            this.$email_pref_toggle_wrap = $('.email-pref-toggle-wrap');
            this.$email_pref_toggle = $('.email-pref-toggle');
            this.$error_msg = $('.alert-email-pref-error');
            this.$success_msg = $('.alert-email-pref-success');
            this.$edit_verified_only = $('#edit-verified-only');
        }
    };

    var apis = {
        save_notification_settings: function(post_data) {
            $.post('/members/user/edit_account_email_settings', post_data)
                .done(function(json) {
                    if (json.success) {
                        events.show_success_msg();
                    } else if (json.error) {
                        events.show_error_msg();
                    }
                });
        },
        add_gdpr: function(post_data) {
            if (typeof post_data != 'undefined' && post_data.hasOwnProperty('gdpr_action')) {

                self.api.json('user.add_gdpr', {
                    type: 'POST',
                    data: post_data
                })
                .done(function(json) {
                    var $alert_div = post_data.gdpr_action == 'remove' ? $('.js-gdpr-remove-error') : $('.js-gdpr-error');

                    if (json && json.error) {
                        var err_msg = (json.error.length ? json.error.join('<br>') : json.error),
                            alert_class = (json.hasOwnProperty('alert_class') ? json.alert_class : 'alert-danger');

                        $alert_div
                            .html(err_msg)
                            .addClass(alert_class)
                            .removeClass('hide');
                        $('.js-gdpr-success').addClass('hide');
                    } else if (json && json.success) {
                        $alert_div.addClass('hide');
                        if (post_data.gdpr_action != 'remove') {
                            $('.js-gdpr-success').removeClass('hide');
                        }

                    }
                })
                .fail(function() {
                    $('.js-gdpr-error')
                        .html('Error!')
                        .addClass('alert-danger')
                        .removeClass('hide');
                    $('.js-gdpr-success').addClass('hide');
                })
                .always(function() {
                    // scroll to top for mobile so user can see success/error msg
                    if (GP.sdata.is_mobile) {
                        $('html, body').animate({ scrollTop: 0 }, 400);
                    }
                });
            }
        }
    };

    var events = {
        init: function() {
            vent.on('init_js:user:edit_account', events.setup_binds);
            vent.on(self.moduleName+":setup_email_pref", events.setup_email_pref);
            vent.on(self.moduleName+":add_gdpr", events.add_gdpr);
            vent.on(self.moduleName+":setup_gdpr_remove_modal", events.setup_gdpr_remove_modal);
            vent.on(self.moduleName+":setup_wywa", events.setup_wywa);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();
            events.setup_email_pref();
        },
        setup_wywa: function() {
            gui.init();
            gui.$edit_verified_only.on('change', events.check_verified);
        },
        setup_email_pref: function() {
            gui.init();
            gui.$email_pref_toggle_wrap.on('click', events.submit_email_pref);
            $('.btn-unsub-email-all').on('click', events.submit_email_pref);
            gui.$email_pref_accept_email.on('click', events.submit_email_pref_accept_email);

            if (gui.$email_pref_accept_email.is(":checked")) {
                $('#email-prefs-wrap-div').show();
            } else {
                $('#email-prefs-wrap-div').hide();
            }
        },
        submit_email_pref_accept_email: function() {
            if (this.checked) {
                $('#email-prefs-wrap-div').show();
            } else {
                $('#email-prefs-wrap-div').hide();
            }

            var _post_data = {
                    'email_pref_accept_email': this.checked ? 1 : 0,
                    'process': 1
                };

            apis.save_notification_settings(_post_data);
        },
        submit_email_pref: function() {
            var _elem = '';
            if ($(this).hasClass('btn-unsub-email-all')) {
                _elem = $(this);
            } else {
                _elem = $(this).find('.email-pref-toggle');
                _elem.toggleClass('on');
            }

            var email_pref = _elem.data('value');

            var _post_data = {
                    'email_pref': email_pref,
                    'status': _elem.hasClass('on') ? 'ENABLED' : 'DISABLED',
                    'process': 1
                };

            if (email_pref == 'UNSUBSCRIBE_ALL') {
                _post_data.status = 'DISABLED';
                gui.$email_pref_toggle.removeClass('on');
            }

            apis.save_notification_settings(_post_data);
        },
        show_error_msg: function() {
            gui.$error_msg.addClass('shown');
        },
        show_success_msg: function() {
            gui.$success_msg.addClass('shown');
        },
        add_gdpr: function(ele_data, $ele) {
            if (typeof ele_data != 'undefined' && ele_data.hasOwnProperty('action')) {
                var post_data = {
                    gdpr_action: ele_data.action
                };

                // trigger confirm modal if action is to remove/delete all data.
                // Otherwise send ajax request without confirm
                if (post_data.gdpr_action == 'remove') {
                    vent.trigger('Modal:open', {
                        url: '/members/user/gdpr_remove/',
                        modal: true
                    });

                } else {
                    apis.add_gdpr(post_data);
                }
            }
        },
        setup_gdpr_remove_modal: function() {
            $('.btn-gdpr-remove-submit').on('click', function() {
                events.submit_gdpr_remove();
            });
            $('.radio-gdpr-reason').on('change', function() {
                $('.js-gdpr-remove-error').addClass('hide');
            });
        },
        submit_gdpr_remove: function() {
            var post_data = {
                gdpr_action: 'remove',
                password: $('.gdpr-password').val(),
                reason_id: null
            };

            $('.radio-gdpr-reason').each(function(index, el) {
                if ($(this).prop('checked')) {
                    post_data.reason_id = $(this).val();
                    return false;
                }
            });

            if (post_data.reason_id == null) {
                apis.add_gdpr(post_data);
                $('.js-gdpr-remove-error')
                    .html('a reason is required.')
                    .removeClass('hide');
            } else {
                apis.add_gdpr(post_data);
            }
        },
        setup_msg_hint_pref_modal: function() {
            $('.btn-save-msg-hint').on('click', function() {
                events.process_msg_hint_pref();
            });
        },
        process_msg_hint_pref: function() {
            var _pref_val = $('.message-hint-pref-modal input[name=msg_approach_pref]:checked').val();

            $.post('/members/msg/add_wywa_setting', {
                msg_prefs: {
                    msg_approach_pref: _pref_val
                },
                from_modal: 1
            }).done(function(json) {
                if (json.status) {
                    GP.vent.trigger("Modal:close");
                }
            });
        },
        check_verified: function() {
            if ($(this).is(':checked')) {
                if (
                    GP.sdata.my_user.verified_pic === 'N' 
                    && GP.sdata.my_user.verified_pic_pending === 'N'
                ) {
                    $(this).prop('checked', false);
                    events.show_verified_modal();
                }
            }
        },
        show_verified_modal: function() {
            GP.vent.trigger('Modal:open', {
                url: '/members/user/verify/?self_view=1',
            });
        },
    };

    this.addInitializer(function(){
        data.init();
        gui.init();
        events.init();

        self.vent.on(self.moduleName+":setup_msg_hint_pref_modal", events.setup_msg_hint_pref_modal, this);
    });
});
